import {NewsBookmarksError} from './NewsBookmarksError.js'

export class DeleteNewsBookmarksError extends NewsBookmarksError {
  constructor(message) {
    super(message)
    this.name = 'DeleteNewsBookmarksError'
  }

  static create(message) {
    return new DeleteNewsBookmarksError(message)
  }
}
